export default __webpack_public_path__ + "static/media/about-cats.5e7d7d5e.webp";